<template>
    <modal :title="'Detail Scan Error Logs/File Name:'+logFile" size="xl" @close="$emit('close')">
        <template #content>
            <loadArea v-if="data==null"></loadArea>
            <pre class="m-0" v-if="data!=null">{{data}}</pre>
        </template>
    </modal>
</template>

<script>
    import axios from "axios";
    export default {
        name:"show",
        props:{
            logFile:String
        },
        data(){
            return{
                addCurrenciesOpen:false,
                model:{
                    Active: false,
                    CurrencyCode: "",
                    DurationBased: false,
                    Id: null,
                    IncreementDayCount: null,
                    IsPortal: false,
                    Logo: null,
                    MainOperatorId: null,
                    MaxDayCount: null,
                    MaxHotelCount: null,
                    Name: "",
                    OutputPort: null,
                    RegionBased: false,
                    ResponseItemCount: null,
                    ScanModel: null,
                    ShortName: "",
                    UsingSameHotelsWithMainOperator: false
                },
                data:null,
                process:false,
                rescanShow:false
            }
        },
        created(){
            axios.get(`https://reservations.ams3.digitaloceanspaces.com/logs/`+this.logFile).then(response => {
                this.data=response.data;
            });
        }
    }
</script>

<style scoped>
    pre{
        box-shadow:none;
    }
</style>